import { render } from "./EmpleadoComponent.vue?vue&type=template&id=6a374109&scoped=true"
import script from "./EmpleadoComponent.vue?vue&type=script&lang=js"
export * from "./EmpleadoComponent.vue?vue&type=script&lang=js"

import "./EmpleadoComponent.vue?vue&type=style&index=0&id=6a374109&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a374109"]])

export default __exports__